<template>
<div id="forgetPassword">
    <mt-header title="找回密码"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
			    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
	</mt-header>
	<div class="mt40"> 
		<p class="text-center pt45"><img src="../../../static/images/logo.png" alt="LOGO" width="90"/></p>
	</div>
	<section class="loginContent" v-show="!shownewpassward">
		<div>
			<div class="login_line">
				<i class="logIco"><img src="../../../static/images/my_ico.png"/></i>
				<input type="tel" placeholder="绑定的手机号" maxlength="11" v-model="phone"/>
			</div>
			<div class="login_line">
				<i class="logIco"><img src="../../../static/images/phone_ico.png"/></i>
				<input type="number" placeholder="手机验证码" v-model="vcode" maxlength="6"/>
				<button class="btnSend" @click="send" :disabled="disabled">
				   <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
	               <span v-if="!sendMsgDisabled">发送验证码</span>
				</button>
			</div>
			<p><input type="button" value="下一步" class="btnLogin" @click="btnLogin"/></p>
		</div>
	</section>
	<section class="loginContent" v-show="shownewpassward">
		<div class="login_linem">
				<i class="logIco"><img src="../../../static/images/change_keyg.png"/></i>
				<input :type="typepasswardo" class="configinput" placeholder="请输入新密码" maxlength="20" v-model="configpassward"/>
				<i @click="changetypeo" class="logIco2"><img :src="srcopeno"/></i>
		</div>
		<!--:class="{disableColor:disableds==true}"-->
		<p><input type="button" value="确认" class="btnLogin" @click="btnLogin2"/></p>
	</section>
 </div>
</template>

<script>
    import { Toast } from 'mint-ui'
	import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
			   time: 60, // 发送验证码倒计时
               sendMsgDisabled: false,
               disabled:false,
               phone:"",//绑定的手机号
               vcode:"",
               configpassward:"", //确认新密码
               shownewpassward:false,//显示确认新密码页面
               typepasswardo:'password',
               srcopeno:'../../../static/images/closeeye.png',
               md5sign:this.Act_md5sign,
			}
		},
	    methods: {
	    	returnBack(){
	       	 this.$router.go(-1);
	       },
	       changetypeo(){
	           if(this.typepasswardo=='password'){
	           	 this.typepasswardo='text';
	           	 this.srcopeno='../../../static/images/openeye.png';
	           }else{
	           	 this.typepasswardo='password';
	           	 this.srcopeno='../../../static/images/closeeye.png';
	           }
	        },
	        //验证用户是否已经注册
	     	send(){
	     		if(this.validatePhone()){
		     		this.$http.post(this.URL_PREFIX+"/user/userIsExistence.net",{phone:this.phone})
					 .then((res) =>{
					 	if(res.data.code!=200){
					 	  Toast(res.data.msg);
					 	}else{
					 	   this.userconfire();
					 	}
					});
				}
	     	},
	    	//发送验证码
	     	userconfire(){
	     		var signM=md5('phone_num='+this.phone+'&'+this.md5sign);
	     		if(this.validatePhone()){
	     		  Indicator.open();
	     		  this.$http.post(this.URL_PREFIX+"/user/sendVerCode.net",{phone_num:this.phone,codeType:1,sign:signM})
				  .then((res) =>{
			  		Indicator.close();
			  		if(res.data.code==404){
			  			Toast(res.data.msg);
			  		}else{
			  			Toast(res.data.msg);
			  			let me = this;
				        me.sendMsgDisabled = true;
				        me.disabled=true;
				        this.showInput=1;
				        let intervald = window.setInterval(function() {
				          if ((me.time--) <= 0) {
				            me.time = 60;
				            me.sendMsgDisabled = false;
				            me.disabled=false;
				            window.clearInterval(intervald);
				          }                    
				        }, 1000);
					}
			  	});
		      }
	        },
            //下一步
	     	btnLogin(){
	     		//console.log(111);
	     	  if(this.validatePhone()){
	     		  if(this.vcode==""){
	     		  	  Toast("请输入手机验证码");
	     		  }else{
	     		  	this.$http.post(this.URL_PREFIX+"/user/updateUserPwdByName.net",{uName:this.phone,verCode:this.vcode})
				  	.then((res) =>{
				  	    if(res.data.code==200){
//				  	       Toast(res.data.msg);
				  	       this.shownewpassward=true;
				  	    }else{
				  	       Toast(res.data.msg);
				  	    }
				  	});  	     		  	 
	     		  }
	     		}
	     	},
	     	btnLogin2(){
	     	  if(this.validatepassword()){
	     		  	this.$http.post(this.URL_PREFIX+"/user/updateUserPwdByName.net",{uName:this.phone,verCode:this.vcode,pwd:this.configpassward})
				  	.then((res) =>{
				  	    if(res.data.code==200){
				  	       Toast(res.data.msg);
				  	       this.$router.push({path: "/Login"});
				  	    }else{
				  	       Toast(res.data.msg);
				  	    }
				  	});  
	     		}
	     	},
	     	//手机号验证
	     	validatePhone(){
	     		var reg=/^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
	     		if(this.phone==''){
                    Toast("请输入手机号码");
                   return false;
                }else if(!reg.test(this.phone)){
                    Toast("手机号格式不正确");
                    return false;
                }else{
                	return true;
                }
	     	},
	     	//登录密码验证
	     	validatepassword(){
//	     		var reg=/^[A-Za-z0-9_~!@#$%^&*￥—+？|/<>=;:`,.\\(){}]{6,20}$/;
	     		var reg= /^[a-zA-Z0-9\W_!@#$%^&*`~()-+=?]{6,20}$/
	     		var reg2 = /\s+/g;
	     		var reg3 = /[\u4E00-\u9FFF]/g;
	     		var reg4 = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
	     		if(this.configpassward==''){
                    Toast("请输入新密码");
                   return false;
                }else if(reg2.test(this.configpassward)){
                   Toast("密码不能包含空格");
                   return false;
                }else if(!reg.test(this.configpassward)){
                    Toast("密码必须为6-20位字母、数字或符号");
                    return false;
                }else if(reg3.test(this.configpassward)){
                    Toast("密码不能包含中文");
                    return false;
                }else if(reg4.test(this.configpassward)){
                    Toast("密码不能包含中文符号");
                    return false;
                }else{
                	return true;
                }
	     	}
	    }
	}
</script>

<style scoped="scoped">
@import "../../../static/css/user.css";
.login_linem{border: 1px solid #e0e0e0 ;padding: 10px;margin-bottom: 10px;overflow: hidden;border-radius: 5px;-webkit-border-radius: 5px;}
.login_linem input{float:left;width: 70%;color: #333;font-size: 1.0rem;border: none;background: transparent;line-height: 30px;margin-left: 20px;}
.configinput{width: 80%;color: #333;font-size: 1rem;border: none;background: transparent;float: left;line-height: 30px;margin-left: 20px;}
/*.loginContent{width: 85%;margin: 150px auto 45px;}
.login_linem{border-bottom: 1px solid #e0e0e0 ;padding: 10px;margin-bottom: 10px;overflow: hidden; display: flex;}
.login_linem input{width: 100%;color: #333;font-size: 1.0rem;border: none;background: transparent;line-height: 30px;margin-left: 20px;}*/
</style>


// WEBPACK FOOTER //
// src/views/UserCenter/forgetPassword.vue